export default __webpack_public_path__ + "static/media/EngrenagemIconBlue.6394df41.svg";